import type { AppProps } from "next/app";
import "@JohnLewisPartnership/core-page-assets/dist/prod/static/core/css/jlp-styles-3.css";
import "../globals.scss";
import { StandardProps } from "@/components/componentMap";

export default function App({ Component, pageProps }: AppProps<StandardProps>) {
  return <Component {...pageProps} />;
}
